import { Box, Divider, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";
import { useLocationContext } from "../../contexts/LocationContext";
import { useOrganizationContext } from "../../contexts/OrganizationContext";
import { useFormatter } from "../../utils/useFormatter";
import { NoDataWarning } from "../common";
import { ScreenMobile } from "../common/ScreenMobile";
import { FormButtonGroup } from "../form";
import { LineInformationScheduleMobile } from "./LineInformationScheduleMobile";
import { AttachMoney } from "@mui/icons-material";

interface IProps {
  open: boolean;
  onClose: VoidFunction;
  setScheduleCancelDialog: any;
  isVirtual: boolean;
  data: any;
  payment: any;
  isPaid: boolean;
}

export function ScreenDetailsScheduleMobile({
  open,
  onClose,
  setScheduleCancelDialog,
  data,
  isVirtual,
  payment,
  isPaid,
}: IProps) {
  const { organizationList } = useOrganizationContext();
  const { location } = useLocationContext();

  const selectedLocation = location?.find((loc: any) =>
    loc?.resource?.id.includes(data?.locationId.id)
  );

  const locationAddress = selectedLocation?.resource?.address?.line?.join(", ");
  const locationContact =
    selectedLocation?.resource?.contact?.[0]?.telecom?.[0]?.value;
  const referenceOrganization =
    selectedLocation?.resource?.managingOrganization?.reference?.split(
      "/"
    )?.[1];

  const organizationContact = organizationList?.find(
    (organization: any) => organization?.resource?.id === referenceOrganization
  )?.resource?.contact?.[0]?.telecom?.[0]?.value;

  const [loading, setLoading] = useState<boolean>(false);

  const handleCancelClick = () => {
    if (!isPaid) {
      setScheduleCancelDialog();
    }
  };

  return (
    <ScreenMobile
      title={`Consulta de ${data?.healthcare}`}
      open={open}
      onClose={onClose}
    >
      {loading ? (
        <NoDataWarning />
      ) : (
        <>
          <LineInformationScheduleMobile
            title="Clínica"
            text={`${useFormatter.formatNameDisplay(data?.location)}`}
          />
          <LineInformationScheduleMobile
            title="Data e horário"
            text={`${dayjs(data?.startTime).format("DD/MM - HH:mm")} horas`}
          />
          <LineInformationScheduleMobile
            title="Profissional"
            text={`${data?.practitioner}`}
          />
          <LineInformationScheduleMobile
            title="Tipo de atendimento"
            text={isVirtual ? `Remoto` : "Presencial"}
          />
          <LineInformationScheduleMobile
            title="Contato"
            text={locationContact || organizationContact || "-"}
          />
          {!isVirtual && locationAddress && (
            <LineInformationScheduleMobile
              title="Localização"
              text={locationAddress}
            />
          )}

          <Divider
            sx={{ mb: 2, width: "100%", background: "neutral400.main" }}
          />

          <LineInformationScheduleMobile title="Última visita" text={``} />

          {isPaid && (
            <Stack 
              direction="row" 
              alignItems="center" 
              justifyContent="center"
              width="100%"
              py={2}
            >
              <Box
                sx={{
                  backgroundColor: "warning100.main",
                  borderRadius: "50%",
                  p: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <AttachMoney sx={{ color: "warning700.main", fontSize: 32 }} />
              </Box>
              <Typography variant="h6" color="warning700.main">
                Consulta já paga
              </Typography>
            </Stack>
          )}

          <FormButtonGroup
            onGoBackButtonClick={onClose}
            onNextButtonClick={handleCancelClick}
            goBackButtonText="Voltar"
            nextButtonText="Cancelar consulta"
            direction="column-reverse"
            disabled={isPaid}
          />
        </>
      )}
    </ScreenMobile>
  );
}
